/**
 * The editor uses Genesis's shared light theme (see app/ui/tokens).
 */
export { S, A, TONES, DARK, labelStyle } from '~/app/ui/tokens';
